module.exports = __webpack_public_path__ + "static/media/50d.5d96d010.svg";